import * as types from "../actionTypes";
import PrivateAPIResource from "../../services/PrivateAPIResource";

export function getMachineRentSuccess(rent) {
    return {type: types.GET_MACHINE_RENT_SUCCESS, rent};
}

export function loadMachineRentsSuccess(rents) {
    return {type: types.LOAD_MACHINE_RENTS_SUCCESS, rents};
}

export function createMachineRentSuccess(rent) {
    return {type: types.CREATE_MACHINE_RENT_SUCCESS, rent};
}

export function updateMachineRentSuccess(rent) {
    return {type: types.UPDATE_MACHINE_RENT_SUCCESS, rent};
}

export function deleteMachineRentSuccess(id) {
    return {type: types.DELETE_MACHINE_RENT_SUCCESS, id};
}

export function resetMachineRent() {
    return {type: types.RESET_MACHINE_RENT_SUCCESS};
}

export function clearImage() {
    return {type: types.CLEAR_MACHINE_RENT_IMAGE_SUCCESS}
}

export function loadMachineRents(page, sortParams) {
    return function (dispatch) {
        return PrivateAPIResource.get('rent-machines?page=' + page, null, sortParams)
            .then(machines => {
                dispatch(loadMachineRentsSuccess(machines));
            }).catch(error => {
                throw error;
            });
    }
}

export function getMachineRent(id) {
    return function (dispatch) {
        return PrivateAPIResource.get('rent-machines', id).then(rent => {
            dispatch(getMachineRentSuccess(rent))
        }).catch(error => {
            throw error;
        });
    }
}

export function createMachineRent(rent) {
    return function (dispatch) {
        return PrivateAPIResource.create('rent-machine/create', rent, true)
            .then(machines => {
                dispatch(createMachineRentSuccess(machines));
            }).catch(error => {
                throw error;
            });
    }
}

export function updateMachineRent(rent, id) {
    return function (dispatch, getState) {
        return PrivateAPIResource.create(`rent-machine/update/${id}`, rent, true).then(rent => {
            dispatch(updateMachineRentSuccess(rent));
        }).catch(error => {
            throw error;
        })
    }
}

export function deleteMachineRent(id) {
    return function (dispatch) {
        return PrivateAPIResource.remove('rent-machine/remove', id).then(machine => {
            dispatch(deleteMachineRentSuccess(id));
        }).catch(error => {
            throw error;
        });
    }
}


// WEBPACK FOOTER //
// ./web/src/actions/machine-rental/machineRentalActions.js